import { useEffect } from 'react';
import { CookiesProvider } from 'react-cookie';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { ConfigProvider, Spin } from 'antd';
import itIT from 'antd/lib/locale/it_IT';
import useModal from 'antd/lib/modal/useModal';
import { ApolloProvider } from '@apollo/client';
import { DeviceIdProvider, useDeviceId } from './device-id';
import { useApolloClient } from './apollo/client';
import AuthRoute from './auth/AuthRoute';
import Onboarding from './pages/onboarding';
import Pages from './pages';
import './App.css';

// bump the version to show the updated notice once to everyone
const STARTUP_MESSAGE_KEY = 'startup-message-v2';

export default function App() {
  return (
    <div className="App">
      <CookiesProvider>
        <ConfigProvider locale={itIT}>
          <DeviceIdProvider>
            <MainLoading />
          </DeviceIdProvider>
        </ConfigProvider>
      </CookiesProvider>
    </div>
  );
}

function MainLoading() {
  const deviceId = useDeviceId();

  return deviceId ? (
    <Main deviceId={deviceId} />
  ) : (
    <div className="MainLoading">
      <Spin size="large" />
    </div>
  );
}

function Main(p: { deviceId: string }) {
  const apolloClient = useApolloClient(p.deviceId);

  const [modal, contextHolder] = useModal();

  useEffect(() => {
    const startupMessage = localStorage.getItem(STARTUP_MESSAGE_KEY);
    if (startupMessage === 'true') return;
    modal.info({
      title: 'Benvenuto!',
      content: (
        <>
          Benvenuto!
          <br />
          Tramite l'App di Progetti Sonori potrai riprodurre video, audio, PDF ed e-book precedentemente acquistati.
          <br />
          <br />
          Potrai utilizzare l'App su un massimo di 3 dispositivi. Ti chiediamo di non utilizzare la navigazione in
          incognito (o privata): il dispositivo potrebbe essere conteggiato come nuovo a ogni accesso. Per qualsiasi
          necessità contatta l'assistenza: app@progettisonori.it - 0722816895.
        </>
      ),
      okText: 'Ok, ho capito.',
    });
    localStorage.setItem(STARTUP_MESSAGE_KEY, 'true');
  }, [modal]);

  return (
    <ApolloProvider client={apolloClient}>
      <BrowserRouter>
        <Switch>
          <Route exact strict path="/(login|register)">
            <Onboarding />
          </Route>
          <AuthRoute>
            <Pages />
          </AuthRoute>
        </Switch>
      </BrowserRouter>
      {contextHolder}
    </ApolloProvider>
  );
}
